import * as React from "react";
import { ConfirmationModal } from '../../base/confirmationmodal';
import { MenuItemProps } from '../../menu/menuitem';
import { BodyHeader } from '../../base/bodyheader';
import { ConnectedAgentEditForm } from '../connected/connected.agenteditform';
import { Profile } from '../../../store/profile/Profile';
import { ConnectedMainDocuments } from '../../documents/connected.maindocuments';
import { UnsavedChanges } from "../../base/unsavedchanges";

export interface AgentEditPageProps {
    isNew: boolean;
    agent: Profile;
    pageLoaded: boolean;
    onLoad?: (id: string) => void;
    onDelete?: () => void;
    onSubmit?: () => void;
}


export class AgentEditPage extends React.Component<AgentEditPageProps>{
    private modalRef: React.RefObject<ConfirmationModal>;
    constructor(props) {
        super(props);
        this.modalRef = React.createRef();
    }

    componentDidMount() {
        if (this.props.onLoad) {
            let id = (this.props as any).match.params.id;
            this.props.onLoad(id);
        }
    }

    private delete() {
        this.modalRef.current.toogleModal();
        if (this.props.onDelete)
            this.props.onDelete();
    }

    render() {

        if (this.props.pageLoaded != true) {
            return (
                <React.Fragment>
                </React.Fragment>)
        }

        let menuItems = [];

        if (this.props.isNew == false) {
            menuItems = [
                {
                    icon: "trash",
                    label: "elimina",
                    isButton: true,
                    isDisabled: false,
                    onClick: () => { this.modalRef.current.toogleModal() }
                }
            ] as Array<MenuItemProps>
        }

        menuItems.push({
            icon: "list",
            label: "lista",
            isButton: false,
            isSmall: true,
            path: "/agents"
        } as MenuItemProps);

        let documents = null;
        if (this.props.isNew == false)
            documents = (<ConnectedMainDocuments objectId={this.props.agent.id} objectName={`${this.props.agent.firstName !== undefined && this.props.agent.firstName != null ? this.props.agent.firstName : ""} ${this.props.agent.lastName} `} />);

        return (
            <React.Fragment>
                <UnsavedChanges confirmAction={this.props.onSubmit} />
                <BodyHeader title={this.props.isNew == true ? "Crea Agente" : "Modifica Agente"} menuItems={menuItems} />
                <ConfirmationModal text="Eliminare agente?" onConfirm={() => this.delete()} ref={this.modalRef} />
                <ConnectedAgentEditForm />
                {documents}
            </React.Fragment>
        )
    }
}